import styled from 'styled-components';

const Container = styled.div({
  paddingLeft: 16,
  paddingRight: 16,
  marginBottom: 16,
  marginTop: 8,
});

export default Container;
